import {nextGUIDId} from "../login/ClientCache";
import {findFieldMetadata} from "../common/Metadata";
import {afterRowInserted, asyncGridAction} from "../actions/BaseDispatcher";
import * as GridAction from "../constants/GridAction";
import {NamaKendoWindow, NamaWindowBtnData} from "../views/NamaKendoWindow";
import {addTask, areNotEqual, busy, getFirstNotNullObj, isNotEmptyOrNull, isNullOrUndefined, removeTask, setFieldValue} from "../common/NamaCommon";
import {IntegerFieldWidget} from "../widgets/IntegerFieldWidget";
import {gridKey, NamaGridLineEditor} from "./NamaGridLineEditor";
import * as notifier from "../common/ErrorsNotification";
import {translateId} from "../common/Translator";
import {isEmptyGridDataItem} from "./NamaGridWidget";

function gridFirstCellId(grid) {
    return grid.columns.flatMap(c => c.columns ? c.columns : c).filter(c => !c.hidden && (!c.attributes || (c.attributes && !c.attributes.readonly)))[0].id;
}

export function gridFocusCell(gridWidget, trIndex, callBack, currentCell, nextOrPrevCell, lastPostActionField) {
    if (busy()) {
        setTimeout(() => gridFocusCell(gridWidget, trIndex, callBack, currentCell, nextOrPrevCell), 250);
        return;
    }
    let grid = gridWidget._kendoGrid();
    if (Number.isInteger(trIndex) && trIndex >= grid.dataSource.pageSize())
        trIndex = trIndex - grid.dataSource.pageSize();
    let currTable = grid.table;
    let currentCellId = gridFirstCellId(grid);
    if (currentCell)
        currentCellId = currentCell.attr("fieldId");
    if (lastPostActionField)
        currentCellId = lastPostActionField;
    let trExpression = Number.isInteger(trIndex) ? ("tr:eq(" + trIndex + ")") : "tr" + trIndex;
    currentCell = [...currTable.find(trExpression + " td[fieldId='" + currentCellId + "']:visible")];
    grid.current(currentCell[0]);
    if (nextOrPrevCell)
        grid._handleEnterKey($(currentCell), currTable[0], currentCell, nextOrPrevCell != "next");
    gridWidget.navigateEditorToCurrent();
    if (callBack)
        callBack();
}

async function deleteRowAction(gridWidget, grid, dataItem) {
    addTask();
    try {
        let currentCell = grid.current();
        let toBeDeletedId = dataItem.id;
        dataItem = grid.dataSource.data().filter(d => d.id === dataItem.id)[0];
        let row = grid.dataSource.data().indexOf(dataItem);
        if (row < 0) row = undefined;
        grid.dataSource.remove(dataItem);
        grid.dataSource.sync();
        let toBeRemoved = grid.dataSource.data().filter(item => item.masterRowId === toBeDeletedId);
        for (let dataItem of toBeRemoved) {
            grid.dataSource.remove(dataItem);
        }
        if (grid.dataSource.data().length == 0) {
            let uuid = await nextGUIDId();
            let ins = grid.dataSource.insert(0, {
                id: uuid
            });
        }
        updateModelLines(grid, gridWidget);
        let fieldMetaData = findFieldMetadata(gridWidget.id, gridWidget.owner.metaData);
        asyncGridAction(gridWidget, row, GridAction.DeleteLine, gridWidget.owner, fieldMetaData, dataItem, currentCell);
        let wentToPrevious = false;
        let current = grid.current();
        if (!current) {
            grid.dataSource.page(grid.dataSource.page() - 1);
            wentToPrevious = true;
        }
        let rowsCount = grid.dataSource.data().length;
        if (rowsCount <= 0) {
            grid.dataSource.page(grid.dataSource.page() - 1);
            wentToPrevious = true;
        }
        if (gridWidget.popupEditor) wentToPrevious = true;

        let currentRowIndex = (current && current.parent() && current.parent().index() >= 0) ? current.parent().index() : Math.max(row - 1, 0);
        if (wentToPrevious || currentRowIndex >= rowsCount) {
            gridFocusCell(gridWidget, ":last", undefined, currentCell);
        } else {
            gridFocusCell(gridWidget, currentRowIndex, undefined, currentCell);
        }
    } catch (e) {
        console.error(e);
    } finally {
        removeTask();
    }
}

export async function deleteRow(e, grid, gridWidget) {
    if (!gridWidget.canDeleteRow()) return;
    if (grid.dataSource.filter()) {
        notifier.showError(translateId("Delete not available with filter"));
        return;
    }
    if (!gridWidget.moreThanOneRowIsSelected()) {
        deleteRowAction(gridWidget, grid, fetchGridCurrentDataItem(grid));
    } else {
        deleteSelectedRows(gridWidget, grid);
    }
}

export function fetchGridCurrentDataItem(grid) {
    if (grid.current())
        return grid.dataItem(grid.current().parent());
    let data = grid.dataSource.data();
    return data[data.length - 1];
}

export function deleteSelectedRows(gridWidget, grid) {
    let rows = gridWidget.findElement().find(".k-grid-content").find("table").find("tr.k-selected");
    let dataItems = [];
    for (let r of rows) {
        dataItems.push(grid.dataItem(r));
    }
    deleteMultiRows(gridWidget, grid, dataItems, 0);
}

function deleteMultiRows(gridWidget, grid, dataItems, counter) {
    for (; counter < dataItems.length;) {
        let dataItem = dataItems[counter];
        if (busy()) {
            setTimeout(() => {
                deleteMultiRows(gridWidget, grid, dataItems, counter);
            }, 200);
            return;
        }
        counter++;
        deleteRowAction(gridWidget, grid, dataItem);
    }

}

export function updateModelLines(grid, gridWidget) {
    let details = [];
    for (let dataLine of grid.dataSource.data()) {
        let line = {};
        for (let key in dataLine) {
            if (dataLine.hasOwnProperty(key) && !(key === "_events" || key === "_handlers")) {
                line[key] = dataLine[key];
            }
        }
        details.push(line);
    }
    gridWidget.owner.setFieldValue(gridWidget.id, details);
}

export async function addLineAndCallGridAction(grid, currentRowAbsoluteIndex, gridWidget, rowViewIndex, copyLine, dataItemToCopy, refSetter, fromQuestionList) {
    addTask();
    try {
        let uuid = await nextGUIDId();
        let cell = grid.current();
        let dataItem = {};
        if (copyLine || refSetter) {
            if (dataItemToCopy.toJSON) dataItem = dataItemToCopy.toJSON(); else dataItem = dataItemToCopy;
        }
        if (copyLine) {
            let fieldMetaData = findFieldMetadata(gridWidget.id, gridWidget.owner.metaData);
            if (isNotEmptyOrNull(fieldMetaData) && isNotEmptyOrNull(fieldMetaData.subFields)) {
                for (let i = 0; i < fieldMetaData.subFields.length; i++) {
                    let subField = fieldMetaData.subFields[i];
                    if (areNotEqual(subField.fieldType, "Binary")) continue;
                    setFieldValue(dataItem, subField.fieldId.substring(gridWidget.id.length + 1), null);
                }
            }
        }
        let dataItemClone = $.extend(true, {}, dataItem);
        dataItemClone.id = uuid;
        dataItemClone.g2Id = uuid;
        if (refSetter && fromQuestionList)
            refSetter(dataItemClone);
        grid.dataSource.insert(currentRowAbsoluteIndex, dataItemClone);
        updateModelLines(grid, gridWidget);
        gridFocusCell(gridWidget, currentRowAbsoluteIndex, null, cell);
        let fieldMetaData = findFieldMetadata(gridWidget.id, gridWidget.owner.metaData);
        if (copyLine) afterRowInserted(gridWidget, copyLine, rowViewIndex, cell); else asyncGridAction(gridWidget, rowViewIndex, GridAction.InsertLine, gridWidget.owner, fieldMetaData, undefined, cell);
        if (refSetter && !fromQuestionList)
            refSetter(dataItemClone);

    } catch (e) {
        console.error(e);
    } finally {
        removeTask();
    }
}

export function realLineKeys() {
    return ["_events", "_handlers", "id", "uid", "dirty", "dirtyFields", "parent", "g2Id"];
}

export async function appendRow(grid, insertAtEnd, gridWidget, ignoreEmptyLines, copyLine, dataItem, rowViewIndex, cellIndex, refSetter, settingLastRef, fromQuestionList) {
    if (!gridWidget.canAppendRow()) return;
    if (grid.dataSource.filter()) return;
    if (!dataItem) dataItem = fetchGridCurrentDataItem(grid);
    if (!ignoreEmptyLines && !refSetter) {
        if (isEmptyGridDataItem(dataItem))
            return;
    }
    let currentRowAbsoluteIndex = getFirstNotNullObj(rowViewIndex, grid.dataSource.indexOf(dataItem));
    if (isNullOrUndefined(rowViewIndex)) {
        rowViewIndex = grid.current().parent().index();
    }
    if (insertAtEnd) {
        rowViewIndex++;
        currentRowAbsoluteIndex++;
    }
    await addLineAndCallGridAction(grid, currentRowAbsoluteIndex, gridWidget, rowViewIndex, copyLine, dataItem, refSetter, fromQuestionList);
    if (isNullOrUndefined(settingLastRef) && rowViewIndex >= grid.dataSource.pageSize()) {
        grid.dataSource.page(grid.dataSource.page() + 1);
    }
    if (settingLastRef && rowViewIndex >= (grid.dataSource.pageSize() * grid.dataSource.page())) {
        gridWidget.changingPage = true;
        grid.dataSource.page((rowViewIndex / grid.dataSource.pageSize()) + 1);
        gridWidget.changingPage = false;
    }
}

export function letterORNumberKeyPressed(e) {
    if (e.keyCode >= 48 && e.keyCode <= 57) return true;
    if (e.keyCode >= 65 && e.keyCode <= 90) return true;
    if (e.keyCode >= 96 && e.keyCode <= 105) return true;
    return false;
}

export function openGridLineEditor(grid_, e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    localStorage.setItem(gridKey(grid_), "true");
    let grid = grid_._kendoGrid();
    let rowIndex = 0;
    if (grid.current())
        rowIndex = grid.current().parent().index();
    if (rowIndex < 0)
        rowIndex = 0;
    if (grid_.findElement().attr("readonlyGrid") === "true" || grid_.allColumnsAreReadOnly(rowIndex)) return;
    let data = grid.dataSource.data();
    let dataItem = data[rowIndex];
    let popupEditor = grid_.popupEditor;
    if (!popupEditor) popupEditor = new NamaGridLineEditor(grid_, dataItem);
    popupEditor.show(dataItem, rowIndex);
}

export function removeEditorPart(grid_, e) {
    let popupEditor = grid_.popupEditor;
    if (!popupEditor) popupEditor = new NamaGridLineEditor(grid_, fetchGridCurrentDataItem(grid_));
    popupEditor.removeEditorPart(e);
}

export function copyLinesAction(grid, gridWidget, copiesCount) {
    if (!gridWidget.moreThanOneRowIsSelected()) {
        let dataItem = grid.dataItem(grid.current().parent());
        let rowIndex = gridWidget._getRowIndex(dataItem.get("id"));
        multiCopyLine(grid, gridWidget, copiesCount, dataItem, rowIndex, grid.current().index());
    } else {
        let rows = gridWidget.findElement().find(".k-grid-content").find("table").find("tr.k-selected");
        let dataItems = [...rows].map(r => grid.dataItem($(r)));
        for (let dataItem of dataItems) {
            multiCopyLine(grid, gridWidget, copiesCount, dataItem, gridWidget._getRowIndex(dataItem.get("id")), 0);
        }
    }
}

export function showLabelsCountDialog(owner, entityType, callBack) {
    let window = new NamaKendoWindow("lablesCount", new NamaWindowBtnData("ok", () => {
        let copiesCount = widget.readValueFromElement();
        callBack(copiesCount);
        window.closeWindow();
    }), new NamaWindowBtnData("cancel"), "25%");

    let widget = new IntegerFieldWidget({owner: window});
    window.addDataWidget(widget.render());
    window.height = "15%";
    widget.afterAttach();
    widget.setValueInElement(1);
    window.showWindow();
}

export function showMultiCopyDialog(grid, gridWidget) {
    if (gridWidget.isCopyRowDisabled()) return;
    showLabelsCountDialog(gridWidget.owner, gridWidget.entityType, (copiesCount) => copyLinesAction(grid, gridWidget, copiesCount));
}

function multiCopyLine(grid, gridWidget, copiesCount, dataItem, rowIndex, cellIndex) {
    let cb = (count) => {
        if (count <= 0) {
            gridWidget._kendoGrid().refresh();
            return;
        }
        if (busy()) {
            setTimeout(() => cb(count), 100);
            return;
        }
        appendRow(grid, true, gridWidget, false, true, dataItem, rowIndex, cellIndex);
        multiCopyLine(grid, gridWidget, parseInt(count) - 1, dataItem, rowIndex, cellIndex);
    };
    cb(copiesCount);

}